import { ChakraProvider, defaultSystem } from '@chakra-ui/react';
import { ThemeProvider } from 'next-themes';

import { useAppConfig } from './app-config-provider';

interface ChakraProviderWithColorModeProps {
  children: React.ReactNode;
}

export function ChakraProviderWithColorMode({
  children,
}: ChakraProviderWithColorModeProps) {
  const { config } = useAppConfig();
  const colorMode = config.colorMode ?? 'light';

  return (
    <ChakraProvider value={defaultSystem}>
      <ThemeProvider
        attribute="class"
        disableTransitionOnChange
        forcedTheme={colorMode}
      >
        {children}
      </ThemeProvider>
    </ChakraProvider>
  );
}
